import React from "react"
import { GlobalAuthProvider } from "./src/context/auth/auth"
import { initialState, authReducer } from "./src/context/auth/authReducer"
import { loadConfig } from "./src/utils/config/config"

const overrideConfig =
  process.env.GATSBY_CONFIG_OVERRIDE &&
  JSON.parse(process.env.GATSBY_CONFIG_OVERRIDE)

// Utility to store tracking parameters
const storeTrackingParams = isAuthenticated => {
  const paramsString = window.location.search
  const searchParams = new URLSearchParams(paramsString)

  let redirectNeeded = false

  searchParams.forEach((value, key) => {
    // if (key.startsWith("utm_")) {
    //   const itmKey = isAuthenticated ? key.replace("utm_", "itm_") : key
    //   sessionStorage.setItem(itmKey, value.trim())

    //   if (isAuthenticated) {
    //     // Update URL to replace utm_ with itm_
    //     searchParams.delete(key)
    //     searchParams.set(itmKey, value.trim())
    //     redirectNeeded = true
    //   }
    // }
    if (key.startsWith("utm_")) {
      searchParams.set(key, value.trim())
      if (isAuthenticated) {
        redirectNeeded = true
      }
    }
  })

  if (redirectNeeded) {
    // Redirect to the updated URL with itm_ parameters
    const newUrl = `${window.location.pathname}?${searchParams.toString()}`
    if (window.location.href !== `${window.location.origin}${newUrl}`) {
      window.location.replace(newUrl) // Full page redirect to ensure URL is updated
    }
  }
}

export function onClientEntry() {
  // Read the authentication status from localStorage
  const userInfo = localStorage.getItem("user_info")
  const isAuthenticated = JSON.parse(userInfo)?.tid || false

  storeTrackingParams(isAuthenticated)
}

let routeJustChangedMarker = null
export function onRouteUpdate({ location, prevLocation }) {
  if (routeJustChangedMarker) {
    // A route change was already registered recently, skip this one.
    // return
  }
  const paramsString = window.location.search
  const searchParams = new URLSearchParams(paramsString)

  const userInfo = localStorage.getItem("user_info")
  const isAuthenticated = JSON.parse(userInfo)?.tid || false

  let hasUTMSaved = false
  let hasITMSaved = false
  const keys = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
    "utm_partner",
  ]

  keys.forEach(key => {
    const value = sessionStorage.getItem(key)
    // const itmKey = isAuthenticated ? key.replace("utm_", "itm_") : key
    const itmKey = key // No need to replace utm_ with itm_ in this case

    if (value) {
      if (isAuthenticated) {
        hasITMSaved = true
        searchParams.set(itmKey, value)
      } else {
        hasUTMSaved = true
        searchParams.set(key, value)
      }
    }
  })

  if (hasUTMSaved || hasITMSaved) {
    window.history.replaceState(
      location.state,
      "",
      `${location.pathname}?${searchParams.toString()}`
    )
  }

  //logic in handling document.referrer for SPA route changes and TID
  const curr_prev_path = localStorage.getItem("previous_path")
  window.locations = window.locations || [document.referrer]
  const locationHref = window.location.href
  const locationOne = window.locations[window.locations.length - 1]
  const locationTwo = window.locations[window.locations.length - 2]
  let prev_path = locationOne

  if (locationHref.includes("/login") || locationHref.includes("/logout")) {
    window.locations.push(curr_prev_path)
  } else {
    if (window.locations[window.locations.length - 1] === "" && window.locations.length === 1) { // no referrer and first entry
      if (curr_prev_path) {
        localStorage.setItem("previous_path", "")
      }
      window.locations.push(window.location.href)
      //console.log("no referrer and first entry - append location.href!")
    } else {
      if (
        locationOne?.includes("id.trimblecloud.com") ||
        locationOne?.includes("id.trimble.com") ||
        locationTwo?.includes("id.trimblecloud.com") ||
        locationTwo?.includes("id.trimble.com")
      ) {
        // do nothing, keep stored previous_path if from TID site
      } else { // not from TID site
        if (window.locations[window.locations.length - 1] !== window.location.href) {
          window.locations.push(window.location.href)
          prev_path = window.locations[window.locations.length - 2]
          localStorage.setItem("previous_path", prev_path)
          //console.log("not from TID site, locationOne !=== locationHref, append location.href, set previous_path!")
        }
      }
    }
  }
  // Set a flag to ignore subsequent calls for a short period (known issue with Gatsby on localdev)
  // routeJustChangedMarker = setTimeout(() => {
  //   routeJustChangedMarker = null
  // }, 500) // 500ms should be enough
}

export const wrapRootElement = ({ element }) => {
  return (
    <GlobalAuthProvider initialState={initialState} reducer={authReducer}>
      {element}
    </GlobalAuthProvider>
  )
}
